import { Image, UIHeading4, UIHeading5 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { AdLabel } from 'shared/components/AdLabel';
import { MortgageAnnotations } from 'shared/components/MortgageAnnotations';
import { Ticker } from 'shared/components/Ticker';

import { type TGetTgbNativedescGeneralCompleteContextResult } from '../../../../utils/getTgbNativedescGeneralCompleteContext';

import styles from './TgbNativedescGeneralMobileCard.css';

export type TTgbNativedescGeneralMobileCardProps = {
  completeContext: TGetTgbNativedescGeneralCompleteContextResult;
};

export const TgbNativedescGeneralMobileCard: FC<TTgbNativedescGeneralMobileCardProps> = ({
  completeContext: {
    title,
    annotation,
    image,
    url,
    label,
    logoImageUrl,
    description,
    mortgageWarning,
    mortgageTermsWarning,
    sizes: { height },
  },
}) => {
  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <a
      className={clsx(styles['container'], withMortgageAnnotations && styles['container--mortgage-annotations'])}
      data-testid="tgb-nativedesc-general-mobile-card"
      style={{ height }}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className={styles['content']}>
        <div className={styles['title-container']}>
          <UIHeading4>{title}</UIHeading4>
          {!!description && <UIHeading5>{description}</UIHeading5>}
        </div>
        {!!logoImageUrl && (
          <div className={styles['logo-container']}>
            <Image src={logoImageUrl} borderRadius="4px" width={40} height={40} objectFit="contain" />
          </div>
        )}
      </div>
      {withMortgageAnnotations && (
        <div className={styles['mortgage-disclaimer']}>
          <MortgageAnnotations
            height={height}
            mortgageWarning={mortgageWarning}
            mortgageTermsWarning={mortgageTermsWarning}
          />
        </div>
      )}
      <div className={styles['photo-block']} style={{ backgroundImage: `url(${image})` }}>
        {!!label && (
          <div className={styles['photo-label']}>
            <AdLabel label={label} />
          </div>
        )}
        {!!annotation && (
          <div className={styles['annotation']}>
            <Ticker theme="dark-background" text={annotation} />
          </div>
        )}
      </div>
    </a>
  );
};
